import { gql } from '@apollo/client';
import { ENROLMENT } from '../fragments';

export const FILTERED_ENROLMENTS = gql`
  query FilteredEnrolments($input: SearchData!) {
    enrolments: filteredSchoolEnrolments(input: $input) {
      aggregate {
        count
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          ...enrolment
        }
      }
    }
  }
  ${ENROLMENT}
`;
